// import Clocking from './Clocking';

export default {
  priority: 97,
  name: app.translate('routes.home.attendance.clocking.Clocking'),
  path: 'clocking',
  permissions: ['TimeAttendanceMenu/ClockingMenu'],
  // component: Clocking,
  component: load(() => import(/* webpackChunkName: "Clocking" */ './Clocking')),
  icon: 'swap-vertical',
  drawer: true,
  description:"بررسی تردد: در صورت استفاده از ماژول موقعیت جغرافیایی، تردد هایی که از طریق تلفن همراه افراد ثبت شده باشد را میتوانید در این قسمت مشاهده کنید. لازم به ذکر است با توجه به اینکه پرسنل در زمان ثبت تردد از طریق اپلیکیشن موبایل نیاز به گرفتن عکس سلفی از خود دارند، میتوانید تصاویر مربوط به هر تردد را در این قسمت به وضوح مشاهده کنید."
};


